import React from "react";
import { Card, Button } from "reactstrap";
import { connect } from "react-redux";
import InfoAlert from "../../../components/Modals/InfoAlert";
import { runSimulation } from "../../../actions/analysis";
import { getCasesAndProjects, openCase } from "../../../actions/cases";

export const RunAnalysis = (props) => {
  return (
    <div style={{ padding: 20 }}>
      <h3 style={{ marginTop: 20, marginBottom: 35 }}>Run</h3>
      <Card body>
        <p style={{ fontWeight: "bold" }}>
          Label:{" "}
          <span style={{ fontWeight: "normal" }}>{props.analysis.label}</span>
        </p>
        <p style={{ fontWeight: "bold" }}>
          Project:{" "}
          <span style={{ fontWeight: "normal" }}>{props.analysis.project}</span>
        </p>
        <p style={{ fontWeight: "bold" }}>
          Description:{" "}
          <span style={{ fontWeight: "normal" }}>
            {props.analysis.description}
          </span>
        </p>
        <Button
          size="lg"
          block
          onClick={() => {
            // check if at least one technology/configuration has been selected
            if (
              props.analysis.PV_run === false &&
              props.analysis.WT_run === false
            ) {
              InfoAlert("At least one from PV and WT must be chosen");
            } else if (props.analysis.load === null) {
              InfoAlert("Choose a Load from the list");
            } else {
              // run here the simulation
              props.runSimulation(
                props.analysis,
                props.history,
                props.getCasesAndProjects,
                props.openCase
              );
            }
          }}
          style={{
            backgroundColor: "#2AC748",
            borderColor: "#2AC748",
            marginTop: 30,
          }}
        >
          Run simulation
        </Button>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  analysis: state.analysis,
});

export default connect(mapStateToProps, {
  runSimulation,
  getCasesAndProjects,
  openCase,
})(RunAnalysis);
